/**
 * Column Control (Meteor)
 */
import { Component, registerComponent } from 'js/component.js';
import { isEditModeFooter } from 'js/helpers.js';
import { initAnimations } from '@RockwellAutomation/rockwell-meteor';
const componentName = 'column-control-meteor';

class ColumnControlMeteor extends Component {

    /**
     * Component Setup
     */
    // Elements
    elements = {
        body: document.body
    };

    /**
     * Initialize Component
     */
    init() {
        if (!isEditModeFooter()) {
            try {
                initAnimations();
            } catch (error) {
                // Suppressing error when already initialized
            }
        }
    }
}

registerComponent(`.${componentName}`, ColumnControlMeteor);
